module.exports = __webpack_public_path__ + "static/Archiveorg-5180f86df625bee2c4b8a78a6507da1c.jpg";